<ng-container *inProductCode="[productCode.Free]">
  @if (showUpgradeBanner$ | async) { @if (isHomePage) {
  <div class="upgrade-banner-card rounded">
    <div class="upgrade-banner-card-image">
      <img alt="" [src]="'banners/upgrade-banner.jpg' | contentAssetImage" />
    </div>
    <div class="upgrade-banner-card-content">
      <div class="upgrade-banner-card-info">
        <h3 class="upgrade-banner-card-title text-white text-uppercase font-page-heading mb-0">
          {{ 'home.page.upgrade.banner.title' | translate : { fgbdefault: 'Upgrade Now' } }}
        </h3>
        <p class="upgrade-banner-card-desc text-white mb-0">
          {{
              'home.page.upgrade.banner.description'
                | translate
                  : {
                      fgbdefault:
                        'Unlock exciting benefits by upgrading your account. Keep an eye out for future promotions and challenges!',
                    }
          }}
        </p>
      </div>
      <a class="upgrade-banner-card-cta rounded fw-bold" [routerLink]="['/membership']">
        {{ 'membership.upgrade.banner.cta' | translate : { fgbdefault: 'Upgrade Now' } }}
      </a>
    </div>
  </div>
  } @else {
  <div class="upgrade-banner rounded">
    <div class="upgrade-banner-logo">
      <img alt="" [src]="'logos/logowhite.png' | contentAssetImage" />
    </div>
    <p class="upgrade-banner-title mb-0 font-page-heading text-uppercase">
      {{
        'membership.upgrade.banner.title' | translate : { fgbdefault: "You're only one step away from receiving more benefits!" }
      }}
    </p>
    <a class="upgrade-banner-cta rounded" [routerLink]="['/membership']">
      {{ 'membership.upgrade.banner.cta' | translate : { fgbdefault: 'Upgrade Now' } }}
    </a>
  </div>
  } }
</ng-container>
